// ReceiptLayoutSettings.jsx
import React, { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// for basic styling

export default function ReceiptLayoutSettings() {
    const [header, setHeader] = useState("");
    const [footer, setFooter] = useState("");

    const handleSave = () => {
        console.log("Header:", header);
        console.log("Footer:", footer);
        alert("Receipt Layout Saved!");
    };

    return (
        <div className="invoicelayout-container my-4">
            <div className="col-md-12">
                <div className="special-header panel-white-all  ">
        <h4 className="page-title mt-1">Invoice Layout Settings</h4>
      </div>
                <div className="receip-bg">
                    <div className="editor-section mb-5">
                        <label>Enter Receipt Header</label>
                        <CKEditor
                            editor={ClassicEditor}
                            data={header}
                            onChange={(event, editor) => setHeader(editor.getData())}
                        />
                    </div>

                    <div className="editor-section">
                        <label>Enter Receipt Footer</label>
                        <CKEditor
                            editor={ClassicEditor}
                            data={footer}
                            onChange={(event, editor) => setFooter(editor.getData())}
                        />
                    </div>
                    <div className="col-lg-12 col-md-12 mt-3 d-flex justify-content-end">
                        <button className="btn custom-btn" onClick={handleSave}> Save </button>
                    </div>

                </div>
            </div>
        </div>
    );
}
